/* eslint-disable no-console */
import React, {
  FC,
  memo,
  useCallback,
  useEffect,
} from 'react';
import { useNavigate } from 'react-router';

import { useScreenWidth } from 'hooks';
import { PathName, ScreenWidth } from 'appConstants';

import { linksOthers, linksOthers2 } from 'components/layout/Footer/constants';
import { links } from '../constants';
import { LinksHead } from '../LinksHead';
import { SignInUsButtons } from '../SignInUsButtons';

import styles from './styles.module.scss';

interface IBurgerMenu {
  onBurgerChange: () => void;
}

export const BurgerMenu:FC<IBurgerMenu> = memo(({ onBurgerChange }) => {
  const isTablet = useScreenWidth(ScreenWidth.tablet);
  const navigate = useNavigate();

  const renamedLinks = [...linksOthers, ...linksOthers2].map(({ title, link }) => ({
    title,
    pathName: link,
  }));

  const handleEclipseDriveClick = useCallback(() => {
    onBurgerChange();
    navigate(PathName.EclipseDrive);
  }, [onBurgerChange, navigate]);

  useEffect(() => {
    if (isTablet) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isTablet]);

  return (
    <div
      className={styles.burger}
    >
      <div className={styles.burger_header}>
        <div className={styles.burger_nav}>
          <LinksHead
            onBurgerChange={onBurgerChange}
            links={links}
          />
          <button
            type="button"
            className={styles.eclipse_drive_link}
            onClick={handleEclipseDriveClick}
          >
            Eclipse Drive
          </button>
        </div>
        {isTablet && <SignInUsButtons onBurgerChange={onBurgerChange} />}
      </div>
      <LinksHead
        onBurgerChange={onBurgerChange}
        isFooterLink
        links={renamedLinks}
      />
    </div>
  );
});
